import { formatDistance } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";
import { LoadingOverlay } from "@mantine/core";
import InlineSearch from "../../../../../shared/ui/inputs/search/InlineSearch";

type Props = {
  events: any,
  query: string,
  onChange: any,
  loading: boolean,
  selected: string,
  setSelected: any,
};

const LeftEventsBar = ({
  events, query, onChange,
  loading, selected, setSelected,
}: Props) => (
  <div className="w-full border-b border-gray-200 flex flex-col bg-white shadow-sm">
    {/* Header section with Events title and search */}
    <div className="sticky top-0 left-0 right-0 px-5 py-3 bg-white z-10 border-b border-gray-200">
      <div className="flex justify-between items-center">
        <h3 className="text-xl font-semibold text-gray-800">Product Usage</h3>
        
        {/* Search input */}
        <div className="w-[250px]">
          <InlineSearch 
            border 
            value={query} 
            onChange={onChange} 
            className="w-full py-2"
          />
        </div>
      </div>
    </div>
    
    {/* Events list section */}
    <div className="flex-1 overflow-x-auto relative">
      <LoadingOverlay visible={loading} loaderProps={{ size: "sm" }} overlayProps={{ blur: 2 }} />
      
      {/* Event items */}
      {events.length > 0 ? (
        <div className="flex flex-row gap-2 px-2 py-4 overflow-x-auto border-b border-gray-200 bg-gray-50">
          {events.map((event: any) => (
            <button
              type="button"
              key={event.event_name}
              className={`flex flex-col bg-white min-w-[180px] text-left px-4 py-3 rounded-lg border transition-colors duration-150 ${selected === event?.event_name ? "bg-purple-50 border-purple-500" : "hover:bg-primary-50 border-gray-200"}`} 
              onClick={() => { setSelected(event?.event_name); }}
            >
              <div className="flex justify-between items-center w-full mb-2">
                <h5 className="text-sm font-medium text-gray-800 truncate max-w-[120px]">
                  {event?.event_name.replace(/_/g, ' ').replace(/\b\w/g, (c: string) => c.toUpperCase())}
                </h5>
                <div className="min-w-[20px] h-[20px] px-2 text-xs flex items-center justify-center rounded-full bg-purple-100 text-purple-700 font-medium">
                  {event?.occurances}
                </div>
              </div>
              <h6 className="text-xs text-gray-500">
                Last seen {formatDistance(zonedTimeToUtc(new Date((event?.last_occured?.replace(" ", "T"))), "UTC"), new Date(), { addSuffix: true })}
              </h6>
            </button>
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center p-5 text-center">
          <svg className="w-12 h-12 text-gray-300 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="text-gray-500 font-medium mb-1">No events found</p>
          <p className="text-gray-400 text-sm">Try changing the time window to see more events</p>
        </div>
      )}
    </div>
  </div>
);

export default LeftEventsBar;
